import React, { Component } from "react";

//Common Functions

import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";

//import "./CustomCSS/charts.css";
export class DashboardOrders extends Component {
  constructor() {
    super();
    this.state = {
      orders: [
        {
          customer: "SprayTec",
          dueDate: "4/02/2020",
          receivedBy: "27/01/2020"
        },
        {
          customer: "John J Higgins",
          dueDate: "2/02/2020",
          receivedBy: "27/01/2020"
        },
        {
          customer: "Stonyford",
          dueDate: "2/02/2020",
          receivedBy: "27/01/2020"
        },
        {
          customer: "Veolia",
          dueDate: "1/02/2020",
          receivedBy: "27/01/2020"
        },
        {
          customer: "SprayTec",
          dueDate: "1/02/2020",
          receivedBy: "27/01/2020"
        }
      ]
    };
  }

  componentDidMount = () => {
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });

    this.setState({ loaded: true, editLoaded: true });
  };

  // #endregion

  // #region View
  render() {
    return (
      <pr.Panel header="Recent Orders" style={{ height: "100%" }}>
        <pr.DataTable value={this.state.orders}>
          <pr.Column field="customer" header="Customer" />
          <pr.Column field="dueDate" header="Due Date" />
          <pr.Column field="receivedBy" header="Received By" />
        </pr.DataTable>
      </pr.Panel>
    );
  }
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardOrders.js